import { format } from "date-fns";

export const formatDate = (date: Date): string => format(date, "MMM d, yyyy");

export const formatMinutes = (minutes: number): string => `${minutes} min`;

export const formatReadingTime = (minutes: number): string =>
  `${formatMinutes(minutes)} read`;

export const pluralize = (
  count: number,
  singular: string,
  plural: string
): string => `${count} ${count === 1 ? singular : plural}`;
